import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api, brl } from "@/lib/api";
import { cachedApi } from "@/lib/cachedApi";
import { wdGender } from "@/lib/weekday";
import { TrendingDown, ChevronRight } from "lucide-react";

/**
 * Alerta de dia fraco no Dashboard — aparece só quando a tela Hoje do
 * Intelligence classifica o dia como fraco (pior que 3 de cada 4 dias
 * comparáveis até o mesmo horário). Checa o recurso antes de chamar
 * `/intelligence/today`: para o plano Basic, o 403 abriria o UpgradePrompt
 * em cima do Dashboard.
 */
export default function WeakDayBanner() {
  const [today, setToday] = useState(null);

  useEffect(() => {
    const role = JSON.parse(localStorage.getItem("oplyx_user") || "{}").role;
    if (!["owner", "manager"].includes(role)) return;
    let alive = true;
    cachedApi("oplyx_feat_v1", () => api.get("/features/me"), 5 * 60 * 1000)
      .then(feat => {
        if (!feat?.features?.intelligence) return null;
        return cachedApi("oplyx_today_v1", () => api.get("/intelligence/today"), 5 * 60 * 1000);
      })
      .then(d => { if (alive && d) setToday(d); })
      .catch(() => {});
    return () => { alive = false; };
  }, []);

  if (today?.pace?.status !== "weak") return null;
  const p = today.pace;
  const top = today.push_products?.[0];

  return (
    <Link
      to="/intelligence/today"
      data-testid="weak-day-banner"
      className="flex items-start gap-3 rounded-xl border border-rose-300 dark:border-rose-500/30 bg-rose-50 dark:bg-rose-500/10 px-5 py-3.5 hover:bg-rose-100/60 dark:hover:bg-rose-500/15 transition-colors"
    >
      <TrendingDown className="w-5 h-5 text-rose-600 dark:text-rose-400 shrink-0 mt-0.5" />
      <div className="flex-1 min-w-0">
        <div className="text-sm font-semibold text-rose-700 dark:text-rose-300">
          Dia abaixo do normal: {brl(p.gap)} atrás {wdGender(p.weekday_plural).dos} {wdGender(p.weekday_plural).seus} {p.weekday_plural}
        </div>
        <div className="text-xs text-neutral-600 dark:text-neutral-300 mt-0.5">
          Pior que {p.beaten_by} de {p.comparable_days} {p.weekday_plural} recentes até este horário.
          {top && <> Para as próximas horas: <strong>{top.product_name}</strong> (margem {top.margin_pct.toLocaleString("pt-BR")}%).</>}
        </div>
      </div>
      <ChevronRight className="w-4 h-4 text-rose-500 shrink-0 mt-0.5" />
    </Link>
  );
}
